import {version} from '$app/environment';
import {logInProduction} from "$lib/utils/logInProduction";

// shortcut >>>  Alt + Apfel + H
export async function hiddenFn() {

    // add dev: label, wenn heikel in production !!!

    // console.log('hidden')
    // logInProduction('version > ' + version)
    //
    // const all = document.querySelectorAll('*').length
    // const inList = document.querySelector('#list')?.querySelectorAll('*').length
    // const inCard = document.querySelector('#card')?.querySelectorAll('*').length
    //
    // console.log('all', all, 'list', inList, 'card', inCard)

}